export default {
  data: () => ({
    model: {},
    errors: {},
  }),

  created() {
    if (!this.fetchModel) {
      return;
    }

    this.fetchData();
  },

  methods: {
    fetchData() {
      let url = this.$route.path;

      this.$api.get(url)
        .then(response => {
          this.setData(response.data);
        })
        .catch(error => {
          if (error.response && error.response.status === 410) {
            this.$router.replace('/410');
          }
        });
    },

    setData(data) {
      for (const key in data) {
        this.$data[key] = data[key];
      }
    },
  }
}